module.exports = __webpack_public_path__ + "img/ロゴ_リセラ.d1f98261.gif";